module.exports = __webpack_public_path__ + "media/images/service de navette-803b7f92467eef890d2979e6c7a6a2e2.svg";